/**
 * @file 防抖函数
 * @author 赵子威<zhaoziwei@baidu.com>
 */

function stopDefault(e) {
    // 阻止默认浏览器动作(W3C)
    if (e && e.preventDefault) {
        e.preventDefault();
    }
    // IE中阻止函数器默认动作的方式
    else {
        window.event.returnValue = false;
    }
    return false;
}

function debounced(fn, {isImmediate = true, delay = 100, arg, modifiers = {}} = {}) {
    let timeout  = null;
    let clickTime = 0;
    let first = true;
    return function (e) {
        if (modifiers.stop) {
            window.event ? window.event.cancelBubble = true : e.stopPropagation();
        }
        if (modifiers.prevent) {
            stopDefault();
        }
        if (isImmediate) {
            first = Date.now() - clickTime > delay;
            clickTime = Date.now();
            if (first) {
                fn(arg);
            }
        }
        else {
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = window.setTimeout(() => {
                fn(arg);
                timeout = null;
            }, delay);
        }
    };
};

const debounce = {
    bind(el, binding) {
        let {arg, modifiers} = binding;
        let fn = null;
        let event = 'click';
        let delay = 300;
        let isImmediate = true;
        if (Object.prototype.toString.call(binding.value) !== '[object Array]') {
            fn = binding.value;
        }
        else {
            [fn, event = 'click', delay = 300, isImmediate = true] = binding.value;
        }
        const init = debounced(fn, {isImmediate, delay, arg, modifiers});
        el.addEventListener(event, init);
    }
};

const directives = {
    debounce
};
function install(Vue) {
    for (const [key, value] of Object.entries(directives)) {
        Vue.directive(key, value);
    }
}

export default {
    install
};